module.exports = __webpack_public_path__ + "img/20210823_123325.f230dcfb.jpg";